import { useTranslation } from 'react-i18next'

import { getRequestApplicantProfileOptions } from '../../../../../api'
import { getItemsFromIdwellApiResponse } from '../../../../../utils/api'
import { FieldStackedLabel } from '../../../../Field'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { useInitiallyOpenSelect } from '../../../../Select'
import { toUserSelectItemsFromOption, UserSelect } from '../../../../User'
import {
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_LABEL_KEYS,
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER,
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_PLACEHOLDER_KEYS,
} from '../../RequestEditApplicantAddressModal.constants'

function RequestEditApplicantAddressModalApplicantField({
  autoFocus,
  ownerApiParams,
}) {
  const { t } = useTranslation()

  const selectStatesRef = useInitiallyOpenSelect(autoFocus)

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Field={FieldStackedLabel}
      Select={UserSelect}
      apiParams={ownerApiParams}
      controlProps={{
        contentProps: {
          inputProps: {
            placeholder: t(
              REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_PLACEHOLDER_KEYS[
                REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER
              ]
            ),
          },
        },
      }}
      fieldComponentProps={{
        label: t(
          REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_LABEL_KEYS[
            REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER
          ]
        ),
        required: true,
      }}
      getData={getRequestApplicantProfileOptions}
      getDataItems={getItemsFromIdwellApiResponse}
      getErrorProps={getFormikFormFieldErrorProps}
      name={REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER}
      selectStatesRef={selectStatesRef}
      toPreparedItems={toUserSelectItemsFromOption}
    />
  )
}

export default RequestEditApplicantAddressModalApplicantField
